// import React from "react";
import "./EventOneMagazine.scss";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const Magazine = () => {
  const options = {
    items: 3,
    dots: false,
    loop: true,
    margin: 30,
    nav: true,
    smartSpeed: 1500,
    autoplay: true,
    autoplayTimeout: 5000,
    responsive: {
      // Define breakpoints and the number of items to show at each breakpoint
      0: {
        items: 1,
        nav: false,
      },
      768: {
        items: 2,
        nav: false,
      },
      992: {
        items: 4,
      },
      1199: {
        items: 4,
      },
    },
  };
  return (
    <div className="Magazine-events">
      <div className="container">
        <div className="Magazine_inner">
          <div className="section_header">
            <div className="left">
              <div className="icon-main">
                <div className="icon">
                  <span class="material-symbols-outlined">newsmode</span>
                </div>
              </div>
              <div className="title">
                <h2>MAGAZINE</h2>
              </div>
            </div>
            <div className="right">
              <button className="event_one_viewall_button">View All</button>
            </div>
          </div>
          <div className="magzine-container">
            <OwlCarousel className="owl-theme my_owl_carousel" {...options}>
              <div className="event-card">
                <div className="image-container">
                  <img
                    src="./assets/img/eventify/cricket2.jpg"
                    className="event-image"
                  />
                  <p>
                    Engines roared and tires screamed as precision met speed on
                    the track, where adrenaline-fueled machines battled for
                    dominance.
                  </p>
                  <div className="badge">CRICKET</div>
                </div>
              </div>
              <div className="event-card">
                <div className="image-container">
                  <img
                    src="./assets/img/eventify/skating2.jpg"
                    className="event-image"
                  />
                  <p>
                    Focused and fierce, players light up the court with every
                    swift shot and strategic move.
                  </p>
                  <div className="badge">SKATING</div>
                </div>
              </div>

              <div className="event-card">
                <div className="image-container">
                  <img
                    src="./assets/img/eventify/racing1.jpg"
                    className="event-image"
                  />
                  <p>
                    Under stadium lights and deep blue skies, cricket unites
                    fans in thrilling evening action.
                  </p>
                  <div className="badge">RACING</div>
                </div>
              </div>
              <div className="event-card">
                <div className="image-container">
                  <img
                    src="./assets/img/eventify/badminton1.jpg"
                    className="event-image"
                  />
                  <p>
                    Speed meets precision as hockey players battle fiercely on
                    the ice for victory.
                  </p>
                  <div className="badge">BADMINTON</div>
                </div>
              </div>
            </OwlCarousel>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Magazine;
